import * as React from "react";
import { Box, Typography } from "@mui/material";
import Socket from "../contents/socket";

export default function Content(props) {
  console.log("contentIndex", props.contentId);

  const RenderPage = ({ contentId = 0 }) => {
    switch (contentId) {
      case 0:
        return <Socket />;

      case 2:
        return <Socket />;

      default:
        return (
          <Box>
            <Typography>No page setup</Typography>
          </Box>
        );
    }
  };

  return <RenderPage contentId={props.contentId} />;
}
